import React from "react";
import { useState, useEffect, useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Row } from "react-bootstrap";
import TasksArchives from "../pages/TasksArchives";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import TasksData from "../pages/TasksData";
import TasksDataExcel from "../pages/TasksDataExcel";
import TaskAdd from "../pages/TaskAdd";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function Tasks({ defaultTab }) {
  const { userData } = useContext(UserDataContext);

  //const [value, setValue] = useState(0);
  const [value, setValue] = useState(defaultTab !== undefined ? defaultTab : 0);
  const [reloadList, setReloadList] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("selectedTabTasks", newValue);
    if (newValue === 1) {
      setReloadList((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (userData) {
      if (userData.permId === "1" || userData.permId === "3") {
        setValue(1);
      } else {
        setValue(0);
      }
    }
  }, [userData]);

  return (
    <div>
      <VN userData={userData} />
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <ThemeProvider theme={theme}>
          {userData && (userData.permId === "1" || userData.permId === "3") ? (
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="underMenu"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
            >
              <Tab label="Rejestracja zlecenia" />
              <Tab label="Lista zleceń" />
              <Tab label="Archiwum" />
              <Tab label="Excel" />
            </Tabs>
          ) : (
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="underMenu"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
            >
              <Tab label="Lista zleceń" />
            </Tabs>
          )}
        </ThemeProvider>
      </Box>
      {userData && (userData.permId === "1" || userData.permId === "3") ? (
        <>
          <CustomTabPanel value={value} index={0}>
            <Row>
              <TaskAdd />
            </Row>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Row>
              <TasksData key={reloadList} />
            </Row>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Row>
              <TasksArchives />
            </Row>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <Row>
              <TasksDataExcel />
            </Row>
          </CustomTabPanel>
        </>
      ) : (
        <CustomTabPanel value={value} index={0}>
          <Row>
            <TasksData />
          </Row>
        </CustomTabPanel>
      )}
    </div>
  );
}
